import React from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import WithLabel, { LABEL_STYLES } from '../../../components/with-label/WithLabel';
import { Input } from '../../../components/common-inputs';
import WithError from '../../../components/with-error/WithError';

function TextInput({ name, label, isRequired, onSubmit, disabled }) {
  const { t } = useTranslation('studio');

  return (
    <WithLabel variant={LABEL_STYLES.COLUMN} label={label} isRequired={isRequired} isBold isTwoDots>
      <Field name={name}>
        {({ input, meta }) => (
          <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
            <Input
              size='sm'
              name={name}
              value={input.value ?? ''}
              onChange={input.onChange}
              formProps={input}
              placeholder={label}
              isError={meta.touched && meta.error}
              onEnter={onSubmit}
              disabled={disabled}
            />
          </WithError>
        )}
      </Field>
    </WithLabel>
  );
}

export default TextInput;
